"use client";

import { SkinnedMeshRenderer } from "../types/avatar";

export const ThuyKieuSkinnedMesh: SkinnedMeshRenderer = (nodes, materials, props, group) => (
  <group {...props} dispose={null} ref={group}>
    <skinnedMesh
      geometry={nodes.AoDaiBK001.geometry}
      material={materials['DefaultMaterial.001']}
      skeleton={nodes.AoDaiBK001.skeleton}
    />
    <skinnedMesh
      geometry={nodes.AoDaiBK002.geometry}
      material={materials['Ta ao']}
      skeleton={nodes.AoDaiBK002.skeleton}
    />
    <skinnedMesh
      geometry={nodes.body002.geometry}
      material={materials.arm}
      skeleton={nodes.body002.skeleton}
    />
    <skinnedMesh
      geometry={nodes.body003.geometry}
      material={materials.arm}
      skeleton={nodes.body003.skeleton}
    />
    <skinnedMesh
      geometry={nodes.body004.geometry}
      material={materials.leg}
      skeleton={nodes.body004.skeleton}
    />
    <skinnedMesh
      geometry={nodes.body005.geometry}
      material={materials.leg}
      skeleton={nodes.body005.skeleton}
    />
    <skinnedMesh
      geometry={nodes.body009.geometry}
      material={materials.eyelash}
      skeleton={nodes.body009.skeleton}
    />
    <skinnedMesh
      name="body016"
      geometry={nodes.body016.geometry}
      material={materials.eyelash}
      skeleton={nodes.body016.skeleton}
      morphTargetDictionary={nodes.body016.morphTargetDictionary}
      morphTargetInfluences={nodes.body016.morphTargetInfluences}
    />
    <skinnedMesh
      geometry={nodes.body018.geometry}
      material={materials.eyelash}
      skeleton={nodes.body018.skeleton}
    />
    <skinnedMesh
      name="body021"
      geometry={nodes.body021.geometry}
      material={materials.teeth}
      skeleton={nodes.body021.skeleton}
      morphTargetDictionary={nodes.body021.morphTargetDictionary}
      morphTargetInfluences={nodes.body021.morphTargetInfluences}
    />
    <skinnedMesh
      name="body022"
      geometry={nodes.body022.geometry}
      material={materials.teeth}
      skeleton={nodes.body022.skeleton}
      morphTargetDictionary={nodes.body022.morphTargetDictionary}
      morphTargetInfluences={nodes.body022.morphTargetInfluences}
    />
    <skinnedMesh
      name="body023"
      geometry={nodes.body023.geometry}
      material={materials.teeth}
      skeleton={nodes.body023.skeleton}
      morphTargetDictionary={nodes.body023.morphTargetDictionary}
      morphTargetInfluences={nodes.body023.morphTargetInfluences}
    />
    <skinnedMesh
      name="EyeLeft"
      geometry={nodes.EyeLeft.geometry}
      material={materials.cornea}
      skeleton={nodes.EyeLeft.skeleton}
      morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
      morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
    />
    <skinnedMesh
      name="EyeRight"
      geometry={nodes.EyeRight.geometry}
      material={materials.cornea}
      skeleton={nodes.EyeRight.skeleton}
      morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
      morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
    />
    <skinnedMesh
      name="PupilLeft"
      geometry={nodes.PupilLeft.geometry}
      material={materials.pupil}
      skeleton={nodes.PupilLeft.skeleton}
      morphTargetDictionary={nodes.PupilLeft.morphTargetDictionary}
      morphTargetInfluences={nodes.PupilLeft.morphTargetInfluences}
    />
    <skinnedMesh
      name="PupilRight"
      geometry={nodes.PupilRight.geometry}
      material={materials.pupil}
      skeleton={nodes.PupilRight.skeleton}
      morphTargetDictionary={nodes.PupilRight.morphTargetDictionary}
      morphTargetInfluences={nodes.PupilRight.morphTargetInfluences}
    />
    <skinnedMesh
      geometry={nodes.shoe.geometry}
      material={materials.shoes}
      skeleton={nodes.shoe.skeleton}
    />
    <skinnedMesh
      geometry={nodes.shoe001.geometry}
      material={materials.shoes}
      skeleton={nodes.shoe001.skeleton}
    />
    <primitive object={nodes.root} />
    <primitive object={nodes['MCH-torsoparent']} />
    <primitive object={nodes['MCH-hand_ikparentL']} />
    <primitive object={nodes['MCH-upper_arm_ik_targetparentL']} />
    <primitive object={nodes['MCH-hand_ikparentR']} />
    <primitive object={nodes['MCH-upper_arm_ik_targetparentR']} />
    <primitive object={nodes['MCH-foot_ikparentL']} />
    <primitive object={nodes['MCH-thigh_ik_targetparentL']} />
    <primitive object={nodes['MCH-foot_ikparentR']} />
    <primitive object={nodes['MCH-thigh_ik_targetparentR']} />
    <skinnedMesh
      name="body025"
      geometry={nodes.body025.geometry}
      material={materials.head}
      skeleton={nodes.body025.skeleton}
      morphTargetDictionary={nodes.body025.morphTargetDictionary}
      morphTargetInfluences={nodes.body025.morphTargetInfluences}
    />
    <skinnedMesh
      name="body025_1"
      geometry={nodes.body025_1.geometry}
      material={materials.body}
      skeleton={nodes.body025_1.skeleton}
      morphTargetDictionary={nodes.body025_1.morphTargetDictionary}
      morphTargetInfluences={nodes.body025_1.morphTargetInfluences}
    />
    <skinnedMesh
      name="body025_2"
      geometry={nodes.body025_2.geometry}
      material={materials.lips}
      skeleton={nodes.body025_2.skeleton}
      morphTargetDictionary={nodes.body025_2.morphTargetDictionary}
      morphTargetInfluences={nodes.body025_2.morphTargetInfluences}
    />
    <skinnedMesh
      name="body025_3"
      geometry={nodes.body025_3.geometry}
      material={materials.lacrimal}
      skeleton={nodes.body025_3.skeleton}
      morphTargetDictionary={nodes.body025_3.morphTargetDictionary}
      morphTargetInfluences={nodes.body025_3.morphTargetInfluences}
    />
    <skinnedMesh
      name="hair001"
      geometry={nodes.hair001.geometry}
      material={materials.hair_front}
      skeleton={nodes.hair001.skeleton}
      morphTargetDictionary={nodes.hair001.morphTargetDictionary}
      morphTargetInfluences={nodes.hair001.morphTargetInfluences}
    />
    <skinnedMesh
      name="hair001_1"
      geometry={nodes.hair001_1.geometry}
      material={materials.hair_back}
      skeleton={nodes.hair001_1.skeleton}
      morphTargetDictionary={nodes.hair001_1.morphTargetDictionary}
      morphTargetInfluences={nodes.hair001_1.morphTargetInfluences}
    />

  </group>
);
